module.exports = __webpack_public_path__ + "static/media/linkedin-circle-border.c10d0788.svg";